<template>
  <v-dialog v-model="dialog" scrollable persistent :max-width="$spec.dialog_standard_max_width">
    <v-card>
      <v-card-title class="headline">你的變更尚未儲存</v-card-title>
      <v-card-text>確定要離開嗎?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="
              dialog = false;
              leaveNext(false);
            "
        >繼續編輯</v-btn>
        <v-btn
          color="leave"
          text
          @click="
              dialog = false;
              leaveNext();
            "
        >離開</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
        
<script>
export default {
  data: () => ({
    dialog: false,
    leaveNext: ""
  }),

  methods: {
    show(leaveNext) {
      this.leaveNext = leaveNext;
      this.dialog = true;
    }
  }
};
</script>